export default "__VITE_ASSET__DfNMorC6__"